import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'src/modules/common/components/Button';
import { ModalBody } from 'src/modules/common/components/ModalBody';
import { ModalFooter } from 'src/modules/common/components/ModalFooter';
import { ModalHeader } from 'src/modules/common/components/ModalHeader';
import { OrganizationUser } from 'src/modules/users/types/OrganizationUser';

type Props = {
  onClose: () => void;
  onDelete: () => void;
  removing: boolean;
  selectedUsers: ReadonlyArray<OrganizationUser>;
};

export const DeleteUserModal = ({ onClose, onDelete, removing, selectedUsers }: Props): React.ReactElement => {
  const intl = useIntl();

  return (
    <>
      <ModalHeader
        handleClose={onClose}
        label={intl.formatMessage({ id: 'admin/user/deleteModal/header/label' })}
        title={intl.formatMessage({ id: 'admin/user/deleteModal/header/title' })}
        danger={true}
      />

      <ModalBody danger={true}>
        {intl.formatMessage(
          { id: 'admin/user/deleteModal/body/content' },
          { users: selectedUsers.map((user) => `${user.firstName} ${user.lastName}`).join(', ') },
        )}
      </ModalBody>

      <ModalFooter>
        <Button
          kind="secondary"
          fullWidth={true}
          autoFocus={true}
          onClick={onClose}
        >
          {intl.formatMessage({ id: 'admin/user/deleteModal/footer/cancel' })}
        </Button>

        <Button
          disabled={removing}
          fullWidth={true}
          kind="danger"
          onClick={onDelete}
        >
          {intl.formatMessage({ id: 'admin/user/deleteModal/footer/confirm' })}
        </Button>
      </ModalFooter>
    </>
  );
};
